import React from 'react';
import Team from '../Team.jsx';

export default function MyTeam() {
  return <Team />;
}
